export const GET_WELCOME_MESSAGE = 'GET_WELCOME_MESSAGE';
export const GET_WELCOME_MESSAGE_BY_ID = 'GET_WELCOME_MESSAGE_BY_ID';
export const SET_WELCOME_MESSAGE = 'SET_WELCOME_MESSAGE';
export const SET_WELCOME_MESSAGE_BY_ID = 'SET_WELCOME_MESSAGE_BY_ID';
export const CREATE_WELCOME_MESSAGE = 'CREATE_WELCOME_MESSAGE';
export const UPDATE_WELCOME_MESSAGE = 'UPDATE_WELCOME_MESSAGE';
export const DELETE_WELCOME_MESSAGE = 'DELETE_WELCOME_MESSAGE';
